export default "__VITE_ASSET__Dx_5uFwQ__"